import { useRef } from 'react'
import styled from 'styled-components'
import SettingsPortal from '../../components/SettingsPortal'
import { useOpenKaito } from './useOpenKaito'
import { FormikProvider } from 'formik'
import { StyledSettings } from '../Cortext/Settings/SettingsStyles.css'

import { options } from './types'
import FormikTextField from 'components/TextFieldFormik'
import TabbedInterface from 'components/TabbedInterface'
import { StyledRoot } from '../Cortext/Cortext'
import ChatInput from '../../components/ChatInput'

import LoadingDots from 'components/Loader/LoadingDots'
import ChatAnimation from '../../components/ChatAnimation'
import SubnetDescription from '../../components/SubnetDescription'
import DropdownFormik from 'components/DropdownFormik'
import Examples from '../../components/Examples'
import { examples } from './constants'

const OpenKaito = () => {
    const kaitotRef = useRef(null)

    const { isLoading, formik, results } = useOpenKaito()

    const { synapse_type } = formik.values

    const pickedSynapse = synapse_type

    return (
        <FormikProvider value={formik}>
            <StyledRoot ref={kaitotRef}>
                <StyledContainer>
                    {isLoading ? (
                        <StyledResponse>
                            <LoadingDots large />
                        </StyledResponse>
                    ) : results ? (
                        <StyledResponse>
                            <TabbedInterface result={results} />
                        </StyledResponse>
                    ) : (
                        <ChatAnimation customSequence={[50, 'Search for clips on any topic']} />
                    )}

                    <StyledFoot>
                        <StyledChatWrapper>
                            <ChatInput formik={formik} fieldName='query_string' />
                        </StyledChatWrapper>
                    </StyledFoot>
                </StyledContainer>
            </StyledRoot>

            <SettingsPortal portalRef={kaitotRef}>
                <StyledSettings>
                    <SubnetDescription
                        title={'5. Open Kaito'}
                        description={
                            'earch engine - Kaito AI is committed to democratizing access to Web3 information through its established platform.'
                        }
                    />

                    <DropdownFormik
                        label='Synapse'
                        fieldName={'synapse_type'}
                        fieldValue={synapse_type}
                        options={options}
                        setFieldValue={formik.setFieldValue}
                    />

                    <FormikTextField name='axon_uid' placeholder={'axon_uid'} label={'Axon UID'} />
                    <FormikTextField name='timeout' placeholder={'timeout'} label={'Timeout'} />
                    <FormikTextField name='size' placeholder={'size'} label={'Size'} />

                    {pickedSynapse === 'StructuredSearchSynapse' && (
                        <FormikTextField
                            name='later_than_timestamp'
                            placeholder={'later_than_timestamp'}
                            label={'Later than timestamp'}
                        />
                    )}

                    {pickedSynapse === 'SemanticSearchSynapse' && (
                        <FormikTextField
                            name='index_name'
                            placeholder={'index_name'}
                            label={'Index name'}
                        />
                    )}

                    <Examples
                        disabled={isLoading}
                        formik={formik}
                        chatInputName={'query_string'}
                        examples={examples}
                    />
                </StyledSettings>
            </SettingsPortal>
        </FormikProvider>
    )
}

export default OpenKaito

const StyledContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    width: 100%;
    height: 100%;
`

const StyledResponse = styled.div`
    width: 100%;
    height: calc(100% - 100px);

    padding-top: 20px;
    padding-right: 20px;
    overflow: auto;

    display: flex;
    justify-content: center;
`
const StyledFoot = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: flex-end;
    justify-content: center;

    max-height: 100px;
`
const StyledChatWrapper = styled.div`
    width: 50%;
`
